import { type FC } from "react"
import { ReactComponent as UserSvg } from "../../assets/svg/user.svg"

const UserIcon: FC = () => <UserSvg/>

export default UserIcon
